import Decimal from 'decimal.js';
import { PricingMethod } from '../entities';
import { TaxInclusiveOption } from '../entities/purchase'

export class PriceUtility {

    public static calculate(method: PricingMethod, costPrice: number, percentageValue: number) {

        let price = 0;
        costPrice = (costPrice as any) == '' ? 0 : costPrice as number;

        switch (method) {
            case PricingMethod.Markup:
            case PricingMethod.CostPlus:
                {

                    const cost = new Decimal(costPrice ?? 0);
                    const percentageIncrease = new Decimal((percentageValue / 100)).mul(cost);

                    price = cost.plus(percentageIncrease).toDP(4).toNumber();

                    break;
                }
            case PricingMethod.TradePlus:
                {
                    const trade = new Decimal(costPrice ?? 0);
                    const percentageIncrease = new Decimal((percentageValue / 100)).mul(trade);
                    price = trade.plus(percentageIncrease).toDP(4).toNumber();

                    break;
                }
            case PricingMethod.SellLess:
                {
                    const rrp = new Decimal(price ?? 0);
                    // const rrp = catalogueCode.retailPrice ?? 0;
                    const percentageDecrease = new Decimal((percentageValue / 100)).mul(rrp);
                    price = rrp.sub(percentageDecrease).toDP(4).toNumber();

                    break;
                }
            case PricingMethod.Margin:
                {
                    //MARGIN = SELL - COST
                    //Profit Percentage = MARGIN / SELL
                    //We know profit percentage and the cost price here, so we can calculate the sell via some Algebra ;)
                    //If an item costs $100 and we want a 30% profit, then sell = $100 / (100% - 30%) = $142.86

                    const cost = new Decimal(costPrice ?? 0);

                    let denominator = 100 - percentageValue;

                    if (denominator <= 0)
                        denominator = 0.0001;

                    const percentage = new Decimal(denominator).div(100);
                    price = cost.div(percentage).toDP(4).toNumber();

                    break;
                }

            case PricingMethod.PriceList:
            case PricingMethod.Manual:
                price = costPrice;
                break;

        }

        return price;

    }

    public static calculateMargin(costPrice: number, sellPrice: number) {
        const sell = new Decimal(sellPrice ?? 0);
        if (sell.isZero()) {
            return 0;
        }

        const cost = new Decimal(costPrice ?? 0);
        const margin = sell.sub(cost).div(sell).mul(100).toDP(2).toNumber();

        return margin;
    }

    public static calculateMarkup(costPrice: number, sellPrice: number) {
        const cost = new Decimal(costPrice ?? 0);
        if (cost.isZero()) {
            return 0;
        }

        const sell = new Decimal(sellPrice ?? 0);
        const markup = sell.sub(cost).div(cost).mul(100).toDP(4).toNumber();

        return markup;
    }

    public static getLineTotals(unitPrice: number, qty: number, taxRate: number, taxOption: TaxInclusiveOption): { totalEx: number, totalInc: number, totalTax: number } {
        const safeQty = (qty ?? 0) * 1;
        const safeTax = taxOption === TaxInclusiveOption.NoTax ? 0 : (taxRate ?? 0) * 1;
        const safeSell = (unitPrice ?? 0) * 1;
        const lineTotal = {
            totalEx: 0,
            totalInc: 0,
            totalTax: 0
        };

        if (taxOption === TaxInclusiveOption.Exclusive) {
            lineTotal.totalEx = new Decimal(safeSell * safeQty).toDP(2).toNumber();
            lineTotal.totalTax = new Decimal(lineTotal.totalEx * (safeTax / 100)).toDP(2).toNumber();
            lineTotal.totalInc = lineTotal.totalEx + lineTotal.totalTax;
        }
        else {
            lineTotal.totalInc = new Decimal(safeSell * safeQty).toDP(2).toNumber();
            lineTotal.totalEx = new Decimal(lineTotal.totalInc / (1 + (safeTax / 100))).toDP(2).toNumber();
            lineTotal.totalTax = lineTotal.totalInc - lineTotal.totalEx;
        }
        return lineTotal;
    }
}